// extracted by mini-css-extract-plugin
module.exports = {"content":"SocialIntegrationErrorModal_content__KwmUB","emptyState":"SocialIntegrationErrorModal_emptyState__ezgFO","actions":"SocialIntegrationErrorModal_actions__v52CT"};